import { CreativeListRecord, CreativeType } from 'core/creative/Creative';
import { NativeCreativeDetail } from './NativeCreativeDetail';
import { VideoCreativeDetail } from './VideoCreativeDetail';
import { ImageCreativeDetail } from './ImageCreativeDetail';
import { PPSCreativeDetail } from './PPSCreativeDetail';
import { HTML5CreativeDetail } from './HTML5CreativeDetail';
import { OutdoorCreativeDetail } from './OutdoorCreativeDetail';
import { ComboCreativeDetail } from './ComboCreativeDetail';
import { CustomLayoutCreativeDetail } from './CustomLayoutCreativeDetail';
import { DynamicCreativeDetail } from './DynamicCreativeDetail';

const detailComponentSettings = {
  [CreativeType.NATIVE]: NativeCreativeDetail,
  [CreativeType.IMAGE]: ImageCreativeDetail,
  [CreativeType.VIDEO]: VideoCreativeDetail,
  [CreativeType.THIRD_PARTY]: PPSCreativeDetail,
  [CreativeType.HTML5]: HTML5CreativeDetail,
  [CreativeType.COMBO]: ComboCreativeDetail,
  [CreativeType.CTV]: VideoCreativeDetail,
  [CreativeType.CUSTOM_RECTANGLE]: CustomLayoutCreativeDetail,
  [CreativeType.CUSTOM_BOTTOM]: CustomLayoutCreativeDetail,
  [CreativeType.SANDBOX_OUTDOOR]: OutdoorCreativeDetail,
  [CreativeType.OUTDOOR_LINE_MESSAGE]: OutdoorCreativeDetail,
  [CreativeType.LINE_MESSAGE]: OutdoorCreativeDetail
};

export interface CreativeDetailModel {
  creative: CreativeListRecord;
  detailComponent: any;
}

export type CreativeDetailProps = {
  model: CreativeDetailModel;
};

export class DefaultCreativeDetailModel implements CreativeDetailModel {
  creative: CreativeListRecord;
  detailComponent: any;

  constructor(creative: CreativeListRecord) {
    this.creative = creative;
    this.detailComponent =
      detailComponentSettings[this.creative.creativeType] ||
      DynamicCreativeDetail;
  }
}
